import { getRequest, postRequest } from 'utils/axios'

export const fetchOrganizationMembers = (organizationUuid, params) => {
  const url = `v2/organizations/${organizationUuid}/members`

  return getRequest(url, params)
}

export const createTeamPlayerInOrganization = (teamUuid, data) => {
  const url = `v2/teams/${teamUuid}/players-with-person`

  return postRequest(url, data)
}


